import React, { useState, useEffect, ChangeEvent, useCallback } from "react";

import { Modal } from "antd";
import faqServiceInstance, { Category, Faq } from "../../../APIs/faq";
import { useNotification } from "../../Toast/Notification";
import HeaderTable from "../HeaderTable/HeaderTable";
import FAQTable from "./blogTable/BlogTable";

const Faqs: React.FC = () => {

  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [filteredFaqs, setFilteredFaqs] = useState<Faq[]>([]);
  const [categories, setcategories] = useState<Category[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const { notify } = useNotification();
  const [currentPage, setCurrentPage] = useState(1);
  const faqsPerPage = 5;
  const [pageNumbers, setPageNumbers] = useState<number[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<any>(1);


  const handleButtonClick = () => {
   
  };

  const fetchCategoriesData = async () => {
    try {
      const { data, error } = await faqServiceInstance.getAllCategories();

      if (data) {
        setcategories(data);
        // setFilteredFaqs(data);
       
      } else {
        console.error("Error fetching FAQs:", error);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  useEffect(() => {
    const id = parseInt(selectedCategoryId, 10);
   
    if (!isNaN(id)) {
      fetchFaqByCategory(id);
    } else {
      console.error("Invalid category ID:", selectedCategoryId);
    }
  }, [selectedCategoryId]);

  const fetchFaqByCategory = async (category_id: number) => {
    try {
      const { data, error } = await faqServiceInstance.getFaqsByCategory(
        category_id
      );

      if (data) {
        setFaqs(data);
        setFilteredFaqs(data);

      } else {
        console.error("Error fetching FAQs:", error);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  useEffect(() => {
    fetchCategoriesData();
  }, []);

  const filterFaqsFromSearch = useCallback(() => {
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const filtered = faqs.filter((faq) =>
      faq.question.toLowerCase().includes(lowerCaseSearchTerm)
    );
    setFilteredFaqs(filtered);
    setCurrentPage(1);
  }, [searchTerm, faqs, setFilteredFaqs, setCurrentPage]);

  useEffect(() => {
    filterFaqsFromSearch();
  }, [searchTerm, faqs, filterFaqsFromSearch]);

  const totalPages = Math.ceil(filteredFaqs.length / faqsPerPage);
  const indexOfLastFaq = currentPage * faqsPerPage;
  const indexOfFirstFaq = indexOfLastFaq - faqsPerPage;
  const currentFaqs = filteredFaqs.slice(indexOfFirstFaq, indexOfLastFaq);

  const generatePageNumbers = useCallback(() => {
    const numbers = [];
    for (let i = 1; i <= totalPages; i++) {
      numbers.push(i);
    }
    setPageNumbers(numbers);
  }, [totalPages, setPageNumbers]);

  useEffect(() => {
    generatePageNumbers();
  }, [generatePageNumbers, totalPages]);

  const handleSearchTermChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleCategoryChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value; 
    const categoryId = parseInt(selectedValue, 10); 
    if (!isNaN(categoryId)) {
      setSelectedCategoryId(categoryId); 
    } else {
      console.error("Invalid selected category:", selectedValue);
    }
  };

  const handleDeleteFAQ = async (faqId: number) => {
    Modal.confirm({
      title: "Are you sure you want to delete this item?",
      content: "This action cannot be undone.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        if (faqId) {
          try {
            const { data, error } = await faqServiceInstance.deleteFaq(
              faqId
            );

            if (data) {
              setFaqs((prev) =>
                prev.filter((acc) => acc.id !== faqId)
              );
         

              notify("Faq deleted successfully", "success");
              // fetchAccData();
              fetchCategoriesData()
             
             
              // setSelectedAccessory(null);
            } else {
              console.error("Error deleting faq:", error);
              notify("Error deleting faq", "error");
            }
          } catch (error) {
            console.error("Error deleting product:", error);
          }
        }
      },
    });
  };

  
  return (
    <div className="p-6">
      <p className="mb-[15px] box-border font-semibold text-[rgb(0,34,56)] block text-[35px] text-left h-auto leading-[38.4px]">
        FAQs
      </p>

      <div className="bg-white p-4 rounded-md w-5/4 mx-auto">
        <HeaderTable
          subtitle="Manage FAQs"
             link="/dashboard/addfaq"
          linkText=" Add New FAQ"
          inputPlaceholder="Search FAQ"
          loading={false}
          searchTerm={searchTerm}
          selectedValue={selectedCategoryId}
          selectPlaceholder="Select Category"
          onButtonClick={handleButtonClick}
          onSelectChange={handleCategoryChange}
          onSearchChange={handleSearchTermChange}
          selectOptions={categories.map((faq) => ({
            value: faq.id.toString(),
            label: faq.name,
          }))}
        />

        <FAQTable
          currentFaqs={currentFaqs}
          loading={false}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
          pageNumbers={pageNumbers}
          faqs={faqs}
          handleDeleteFAQ={ handleDeleteFAQ}
        />

      </div>
    </div>
  );
};

export default Faqs;
